import { FC, useState, useEffect } from 'react';
import {
  Tooltip,
  Modal,
  Divider,
  Box,
  IconButton,
  Typography,
  Button,
  useTheme,
  Card,
  Container
} from '@mui/material';
import { DataGrid, GridToolbar,GridRowParams } from '@mui/x-data-grid';
import axios from 'axios';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import { CryptoOrder, CryptoOrderStatus } from 'src/models/crypto_order';

import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import './userNotFound.css';
import PageTitleWrapper from 'src/components/PageTitleWrapper';

interface CategoryListTableProps {
  className?: string;
}
interface Filters {
  status?: CryptoOrderStatus;
}

const applyFilters = (
  cryptoOrders: any[],
  filters: Filters
): CryptoOrder[] => {
  return cryptoOrders.filter((cryptoOrder) => {
    let matches = true;
    return matches;
  });
};
const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 480,
  //bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const UserNotFound: FC<CategoryListTableProps> = ({ }) => {
  const [value, setValue] = useState(0);
  const [cryptoOrders, setcryptoOrdersPage] = useState([]);
  const [selectedCryptoOrders, setSelectedCryptoOrders] = useState([]);
  const [open, setOpen] = useState(false);
  const [clickedID, setClickedID] = useState(null);
  const [deleteButton, setDeleteButton] = useState(false);
  const [filters, setFilters] = useState<Filters>({
    status: null
  });
  const filteredCryptoOrders = applyFilters(cryptoOrders, filters);

  const navigate = useNavigate();
  const theme = useTheme();


  const handleOpen = (id) => {
    setOpen(true);
    setClickedID(id);
  };

  const handleClose = () => {
    setOpen(false);
    setClickedID(null);
  };

  const handleDeleteData = async (id) => {
    try {
      setDeleteButton(true);
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/userNotFound/delete/${id}`);
      toast.success('User  Deleted Successfully!', { position: "bottom-right" });
     PendingData();
      handleClose();
    } catch (error) {
      toast.error(error?.response?.data?.message, { position: "bottom-right" });
    } finally {
      setDeleteButton(false);
    }
  };

  const columns = [    
  
    {
      field: 'name',
      headerName: 'Name',
      flex:1,
    },
    {
      field: 'mobile',
      headerName: 'PhoneNumber',
      flex:1 ,
    },
    {
      field: 'Actions',
      headerName: 'Actions',
      sortable: false,
      filterable: false,
      width: 150,
      disableClickEventBubbling: true,

      renderCell: (params) => (
        <>
         

          <Tooltip title="Delete User" arrow>
            <IconButton
                 sx={{
                  '&:hover': {
                    background: theme.colors.primary.lighter
                  },
                  color: theme.palette.primary.main
                }}
                color="inherit"
                size="small"
            >
              {/* <DeleteTwoToneIcon fontSize='small' /> */}

              {params.row.role == "Admin" ? "" : (
                  <DeleteTwoToneIcon fontSize='small'
                    onClick={() => handleOpen(params.row._id)}
                    className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
                  />
                )}
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  const  PendingData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/userNotFound/list`);
      if (response?.data?.data) {
        setcryptoOrdersPage(response?.data?.data);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message, { position: "bottom-right" });
    }
  };

  useEffect(() => {
     PendingData();
  }, []);

  return (
    <>
      <Container maxWidth="lg">
      <PageTitleWrapper>
        
      <p
  style={{
    margin: '0px',
    width: '100%',
    color: 'black', // or any bright color you prefer
    fontWeight: 'bold',
    fontSize: '24px',  // make the text bigger
 
    letterSpacing: '1px', // add slight spacing between letters
    marginBottom: '20px',
  }}
>
  New Request
</p>

      </PageTitleWrapper>
      </Container>
       <Container maxWidth="lg">
       <Card>
      
      <Box sx={{ p: 3 }}>
      <Divider variant="middle" />
      <div className="table">


        <DataGrid
          rows={cryptoOrders}
          getRowId={(row) => row._id}
          columns={columns}
          className="mybonustable widthtable"
          slots={{ toolbar: GridToolbar }}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 10, page: 0 }
            }
          }}
        />
        </div>

      </Box>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h3" component="h2">
            Are you sure to delete?
          </Typography>
          <hr />

          <Button
            type="submit"
            sx={{ mt: 2, mr: 2 }}
            variant="contained"
            onClick={() => handleDeleteData(clickedID)}
            disabled={deleteButton}
          >
            Yes
          </Button>

          <Button
            type="submit"
            sx={{ mt: 2 }}
            variant="contained"
            onClick={() => handleClose()}
          >
            Cancel
          </Button>
        </Box>
      </Modal>
      </Card>
      </Container>
    </>
  );
};

export default UserNotFound;